import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/insurers/claims/store/claimSlice/initialState.ts'
import { Claim } from '@/modules/insurers/claims/types/Claim.ts'

const claimSlice = createSlice({
  name: 'claim',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setClaims: (state, action: PayloadAction<Claim[]>) => {
      state.claims = action.payload
    },
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const claimActions = claimSlice.actions
export const { reducer: claimReducer } = claimSlice
